import { User } from "./../../../core/models/users/user.models";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
} from "@angular/forms";
import moment from "moment";

import { LangUtils, LocalStorage } from "src/app/core/utils";
import { UserSettingsProfileModel } from "src/app/core/models/users";
import { TranslateService } from "@ngx-translate/core";
import { AlertService, TitleService } from "src/app/core/services/shared";
import { LoginService } from "src/app/core/services/login";
import { UsersService } from "src/app/core/services/users";
import { MastersService } from "src/app/core/services/masters";
import { RegisterService } from "src/app/core/services/register/register.service";
import { UsersRegisterMapperService } from "src/app/core/services/mapper";
import { IdiomaModel } from "src/app/core/models/masters/idioma.model";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateAdapter } from "@angular/material/core";
import { GetDataService } from "src/app/core/services/get-data/get-data.service";
import { LOCALSTORAGESTRINGS } from "src/app/core/models/masters/localstorage.enum";
import {
	DEFAULTMOBILEPREFIX,
	DomainTypes,
} from "src/app/core/models/masters/masters.enum";
import { forkJoin, Observable } from "rxjs";
import { PrefixCountry } from "src/app/core/models/shared/prefixCountry.model";
import { finalize, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MODAL_DIALOG_TYPES } from "src/app/core/utils/modal-dialog-types";
import { ModalAjustesUsuarioComponent } from "src/app/shared/components/modal-ajustes-usuario/modal-ajustes-usuario.component";
import { ToasterService } from "src/app/core/services/shared/toaster.service";
import { Store } from "@ngrx/store";
import { State } from "src/app/store/models/store.model";
import { selectProfile } from "src/app/store/actions/selected-profile.action";

@Component({
    selector: "app-user-data",
    templateUrl: "./user-data-general.component.html",
    styleUrls: ["./user-data-general.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class UserDataGeneralComponent implements OnInit {
	@Output() idiomaSeleccionado: EventEmitter<number> = new EventEmitter();
	@ViewChild('smsCodeInput') smsCodeInput: ElementRef;

	formularioDatos: UntypedFormGroup;

	$phonePrefixes: Observable<PrefixCountry[]>;

	validationMessages = {
		firstName: [],
		surname: [],
		mail: [],
		birthdate: [],
		mobile: [],
		gender: [],
		prefix: [],
	};

	isDemo: boolean = environment.domain === DomainTypes.DEMO ? true : false;

	userData: User;

	usersSettingsProfileData: UserSettingsProfileModel;

	genres: any[] = [];

	public loading = false;
	profilesLoaded: boolean = false;

	langList: IdiomaModel[];
	availableLangs: String[];
	private _maxLength: number = 15;
	private currentLang: string;
	screenView: number = 1;
	year: number;
	showBirthdate: any;
	isAdult: boolean;

	isMobile: boolean = false;

	originalMobile: string = "";
	originalPrefix: string = "";
	originalMail: string = "";
	smsSent: boolean = false;
	smsVerifying: boolean = false;
	pendingSmsPin: string = "";
	pinError: boolean = false;
	emailExists: boolean = false;

	constructor(
		private formBuild: UntypedFormBuilder,
		public translateService: TranslateService,
		private titleService: TitleService,
		private alertService: AlertService,
		private localStorage: LocalStorage,
		public loginService: LoginService,
		public usersService: UsersService,
		private usersRegisterMapperService: UsersRegisterMapperService,
		private dateAdapter: DateAdapter<Date>,
		private lang: LangUtils,
		private activeModal: NgbActiveModal,
		private dataService: GetDataService,
		private mastersService: MastersService,
		private modalService: NgbModal,
		private toaster: ToasterService,
		private store: Store<State>,
		private masterService: MastersService,
		private registerService: RegisterService,
	) {}

	ngOnInit(): void {
		this.isMobile = window.innerWidth < 1200;
		this.obtenerDatosMaestros();
		this.traducirOpciones();
		this.crearFormulario();
		this.cargarValidacionesFormulario();
		this.obtenerDatosUsuario();

		this.currentLang = this.localStorage.getItem(LOCALSTORAGESTRINGS.LANG);
		this.dateAdapter.setLocale(this.currentLang);
	}

	private obtenerDatosMaestros() {
		this.mastersService.getAllGenders().subscribe((data) => {
			this.genres = data;
		});

		this.getAllLanguages();
		this.$phonePrefixes = this.loginService.getPhonePrefix();
		this.masterService.setIdTutorialContext(99);
	}

	getAllLanguages() {
		this.langList = this.dataService.appLanguages;
		this.availableLangs = this.langList.map((e) => e.idLanguageIso.toLowerCase());
		this.lang.setAppLang(this.availableLangs);
	}

	validateIdUserIsAdult(birthDate) {
		const currentYear = new Date().getFullYear();
		const parsedYear = Number((birthDate || "").slice(0, 4));
		this.year = Number.isFinite(parsedYear) && parsedYear > 0 ? parsedYear : currentYear;
		const isAdults = currentYear - this.year;
		this.showBirthdate = true;
		this.isAdult = isAdults > 17;
	}

	private traducirOpciones() {
		this.translateService
			.get("USERDATA.CONFIGURACION")
			.subscribe((res: string) => {
				this.titleService.setHTMLTitle(res);
				this.titleService.setBarTitle(res);
			});
	}

	private crearFormulario() {
		this.formularioDatos = this.formBuild.group({
			idUser: [this.loginService.getUser().idUser],
			firstName: ["", [Validators.minLength(2), Validators.required]],
			surname: [""],
			pictureUser: [""],
			mail: [""],
			birthdate: [""],
			mobile: new UntypedFormControl("", [Validators.maxLength(this._maxLength)]),
			idGenre: [""],
			idLanguageIso: [""],
			picture: [""],
			prefix: ["", Validators.required],
			profileEditor: [true, Validators.required],
			profileStudent: [false],
			profileTeacher: [false],
			profileParent: [false],
			profileCenter: [false],
		});
	}

	get prefixControl(): UntypedFormControl {
		return this.formularioDatos
			? (this.formularioDatos.get("prefix") as UntypedFormControl)
			: null;
	}

	private cargarValidacionesFormulario() {
		this.translateService
			.get("VALIDACIONES.ELNOMBREESOBLIGATORIO")
			.subscribe((res: string) => {
				this.validationMessages.firstName.push({
					type: "required",
					message: res,
				});
			});

		this.translateService
			.get("VALIDACIONES.LOSAPELLIDOSSONOBLIGATORIOS")
			.subscribe((res: string) => {
				this.validationMessages.surname.push({
					type: "required",
					message: res,
				});
			});

		this.translateService
			.get("VALIDACIONES.ELEMAILESOBLIGATORIO")
			.subscribe((res: string) => {
				this.validationMessages.mail.push({ type: "required", message: res });
			});

		this.translateService
			.get("VALIDACIONES.ELTELEFONOMOVILESOBLIGATORIO")
			.subscribe((res: string) => {
				this.validationMessages.mobile.push({ type: "required", message: res });
			});

		this.translateService
			.get("VALIDACIONES.MAXLENGTH")
			.subscribe((res: string) => {
				this.validationMessages.mobile.push({
					type: "maxlength",
					message: res.replace("{1}", `${this._maxLength}`),
				});
			});

		this.translateService
			.get("VALIDACIONES.LAFECHADENACIMIENTOESOBLIGATORIA")
			.subscribe((res: string) => {
				this.validationMessages.birthdate.push({
					type: "required",
					message: res,
				});
			});
		this.translateService
			.get("VALIDACIONES.ESCOGEUNAOPCION")
			.subscribe((res: string) => {
				this.validationMessages.gender.push({ type: "required", message: res });
			});
	}

	public mostrarMensajeAviso() {
		const resp = this.usersService.checkIfUserDataAreRegistered(
			this.userData,
			"general"
		);

		if (resp.result !== true) {
			this.alertService.info(
				this.translateService.instant(resp.mensaje),
				AlertService.AlertServiceContextValues.UserData
			);
		} else {
			this.alertService.clear();
		}
	}

	private cargarDatosFormulario() {
		let birthDate: string = this.userData.birthdate
			? moment(this.userData.birthdate).format("YYYY-MM-DD")
			: "";

		this.formularioDatos.controls.idUser.setValue(this.userData.idUser);
		this.formularioDatos.controls.pictureUser.setValue(
			this.userData.pictureUser
		);
		this.formularioDatos.controls.firstName.setValue(this.userData.firstName);
		this.formularioDatos.controls.surname.setValue(this.userData.surname);
		this.formularioDatos.controls.mail.setValue(this.userData.mail);
		this.formularioDatos.controls.birthdate.setValue(birthDate);
		this.formularioDatos.controls.mobile.setValue(this.userData.mobile);
		this.formularioDatos.controls.idGenre.setValue(this.userData.idGenre);
		this.formularioDatos.controls.idLanguageIso.setValue(
			this.userData.idLanguageIso.toLocaleUpperCase()
		);
		this.formularioDatos.controls.picture.setValue(this.userData.pictureUser);
		const prefixValue = this.userData.extension
			? "+" + this.userData.extension
			: DEFAULTMOBILEPREFIX;
		this.formularioDatos.controls.prefix.setValue(prefixValue);

		this.originalMobile = this.userData.mobile || "";
		this.originalPrefix = prefixValue;
		this.originalMail = this.userData.mail || "";
		this.formularioDatos.controls.profileEditor.setValue(true);
		this.formularioDatos.controls.profileStudent.setValue(
			this.userData.profileStudent
		);

		this.formularioDatos.controls.profileTeacher.setValue(
			this.userData.profileTeacher
		);
		this.formularioDatos.controls.profileParent.setValue(
			this.userData.profileParent
		);
		this.formularioDatos.controls.profileCenter.setValue(
			this.userData.profileCenter
		);
		this.validateIdUserIsAdult(birthDate);
	}

	private obtenerDatosUsuario() {
		this.loading = true;
		this.profilesLoaded = false;

		forkJoin({
			user: this.usersService.getUserByIdUser(this.loginService.getUser().idUser),
			profiles: this.usersService.getListUserProfile(),
		})
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				({ user, profiles }: any) => {
					if (!user || user.idUser === 0) {
						this.alertService.error(
							this.translateService.instant("ERROR.HAOCURRIDOUNERROR"),
							AlertService.AlertServiceContextValues.UserData
						);
						return;
					}

					this.userData = this.usersRegisterMapperService.transform(user);
					this.usersSettingsProfileData = user.usersSettingsProfiles;

					// Default seguro: asumimos que es editor hasta que el listado de perfiles
					// confirme lo contrario. Evita el parpadeo del aviso rojo mientras carga.
					this.userData.profileEditor = true;
					this.userData.profileStudent = false;
					this.userData.profileTeacher = false;
					this.userData.profileParent = false;
					this.userData.profileCenter = false;

					const profileList = profiles?.data ?? [];
					const hasEditor = profileList.some((p: any) => p.idProfile === 1);
					this.userData.profileEditor = hasEditor;
					this.userData.profileStudent = profileList.some((p: any) => p.idProfile === 2);
					this.userData.profileTeacher = profileList.some((p: any) => p.idProfile === 3);
					this.userData.profileParent = profileList.some((p: any) => p.idProfile === 4);
					this.userData.profileCenter = profileList.some((p: any) => p.idProfile === 6);

					this.profilesLoaded = true;

					this.cargarDatosFormulario();
					this.mostrarMensajeAviso();
				},
				() => {
					this.alertService.error(
						this.translateService.instant("ERROR.HAOCURRIDOUNERROR"),
						AlertService.AlertServiceContextValues.UserData
					);
				}
			);
	}

	public grabarDatos() {
		if (this.emailExists) {
			return;
		}

		if (this.isMobileChanged() && this.pendingSmsPin.length !== 6) {
			this.toaster.error(this.translateService.instant("CAMBIARMOVIL.VERIFYBEFORESUBMIT"));
			return;
		}

		if (this.isMobileChanged() && this.pendingSmsPin.length === 6) {
			this.validateEmail().then((valid) => {
				if (valid) {
					this.saveFormDataAndChangeMobile();
				}
			});
			return;
		}

		this.validateEmail().then((valid) => {
			if (!valid) return;
			this.doSaveFormData();
		});
	}

	private doSaveFormData() {
		const campos = this.formularioDatos.value;

		// Usuario sin perfil editor: solo puede modificar nombre y apellidos
		if (!this.userData.profileEditor) {
			this.loading = true;
			this.userData.firstName = campos.firstName;
			this.userData.surname = campos.surname;
			this.usersService
				.updateUser(this.userData)
				.pipe(finalize(() => (this.loading = false)))
				.subscribe(
					() => {
						this.changeLang(this.userData.idLanguageIso);
						this.alertService.success(
							this.translateService.instant(
								"USERDATA.LOSDATOSSEHANGRABADOCORRECTAMENTE"
							),
							AlertService.AlertServiceContextValues.UserData
						);
					},
					() => {
						this.alertService.error(
							this.translateService.instant("ERROR.HAOCURRIDOUNERROR"),
							AlertService.AlertServiceContextValues.UserData
						);
					}
				);
			return;
		}

		if (this.formularioDatos.invalid) {
			return;
		}

		this.loading = true;

		this.userData.firstName = campos.firstName;
		this.userData.idGenre = campos.idGenre;
		this.userData.mail = campos.mail;
		this.userData.mobile = campos.mobile;
		this.userData.surname = campos.surname;
		this.userData.birthdate = campos.birthdate;
		this.userData.idLanguageIso = campos.idLanguageIso.toLowerCase();
		this.userData.extension = (campos.prefix as string).replace("+", "").trim();
		this.userData.profileEditor = campos.profileEditor;
		this.userData.profileStudent = campos.profileStudent;
		this.userData.profileTeacher = campos.profileTeacher;
		this.userData.profileParent = campos.profileParent;
		this.userData.profileCenter = campos.profileCenter;
		this.userData.identification = this.loginService.getUser().identification;

		forkJoin({
			user: this.usersService.updateUser(this.userData),
			profile: this.usersService.updateUserProfile(campos),
		})
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				() => {
					this.changeLang(this.userData.idLanguageIso);
					this.alertService.success(
						this.translateService.instant(
							"USERDATA.LOSDATOSSEHANGRABADOCORRECTAMENTE"
						),
						AlertService.AlertServiceContextValues.UserData
					);
				},
				() => {
					this.alertService.error(
						this.translateService.instant("ERROR.HAOCURRIDOUNERROR"),
						AlertService.AlertServiceContextValues.UserData
					);
				}
			);
	}

	public guardarPerfil() {
		this.usersService.updateUserProfile(this.formularioDatos.value).subscribe();
	}

	isMobileChanged(): boolean {
		if (!this.formularioDatos) return false;
		const currentMobile = this.formularioDatos.controls.mobile.value || "";
		const currentPrefix = this.formularioDatos.controls.prefix.value || "";
		return currentMobile !== this.originalMobile || currentPrefix !== this.originalPrefix;
	}

	requestSmsVerification() {
		const mobile = this.formularioDatos.controls.mobile.value;
		const prefix = (this.formularioDatos.controls.prefix.value as string).replace("+", "").trim();

		if (!mobile || !prefix) return;

		this.smsVerifying = true;
		this.pinError = false;
		this.pendingSmsPin = "";
		if (this.smsCodeInput) {
			this.smsCodeInput.nativeElement.value = "";
		}
		this.registerService.mobileRequestSms(prefix, mobile).subscribe(
			(res) => {
				this.smsVerifying = false;
				if (res.error_id === "INVALID_NUMBER") {
					this.toaster.error(this.translateService.instant("CAMBIARMOVIL.WRONGPHONE"));
				} else if (res.error_id === "PHONE_NUMBER_ALREADY_USED") {
					this.toaster.error(this.translateService.instant("REGISTRO.MAILORPHONEEXIST"));
				} else {
					this.toaster.success(this.translateService.instant("CAMBIARMOVIL.CODESENDED"));
					this.smsSent = true;
				}
			},
			() => {
				this.smsVerifying = false;
				this.toaster.error(this.translateService.instant("ERROR.HAOCURRIDOUNERROR"));
			}
		);
	}

	onPinInput(ev: any) {
		this.pendingSmsPin = ev.target.value;
	}

	private saveFormDataAndChangeMobile() {
		this.loading = true;
		const campos = this.formularioDatos.value;
		this.userData.firstName = campos.firstName;
		this.userData.idGenre = campos.idGenre;
		this.userData.mail = campos.mail;
		this.userData.surname = campos.surname;
		this.userData.birthdate = campos.birthdate;
		this.userData.idLanguageIso = campos.idLanguageIso.toLowerCase();
		this.userData.profileEditor = campos.profileEditor;
		this.userData.profileStudent = campos.profileStudent;
		this.userData.profileTeacher = campos.profileTeacher;
		this.userData.profileParent = campos.profileParent;
		this.userData.profileCenter = campos.profileCenter;
		this.userData.identification = this.loginService.getUser().identification;

		this.usersService.updateUserProfile(campos).subscribe();

		this.usersService.updateUser(this.userData)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				() => this.verifyPinAndLogout(),
				() => this.verifyPinAndLogout()
			);
	}

	private verifyPinAndLogout() {
		const mobile = this.formularioDatos.controls.mobile.value;
		const prefix = (this.formularioDatos.controls.prefix.value as string).replace("+", "").trim();

		this.usersService.changeMobile(mobile, prefix, this.pendingSmsPin).subscribe(
			(res: any) => {
				if (res?.error?.code === 0) {
					this.toaster.success(this.translateService.instant("CAMBIARMOVIL.PHONEEDITED"));
					this.activeModal.close(true);
					localStorage.removeItem('selectedGroupInfo');
					this.loginService.logout(true);
				} else {
					this.handlePinError();
				}
			},
			() => {
				this.handlePinError();
			}
		);
	}

	private handlePinError() {
		this.loading = false;
		this.pinError = true;
		this.pendingSmsPin = "";
		if (this.smsCodeInput) {
			this.smsCodeInput.nativeElement.value = "";
		}
		this.toaster.error(this.translateService.instant("CAMBIARMOVIL.ERRORCODE"));
	}

	isMailChanged(): boolean {
		if (!this.formularioDatos) return false;
		const currentMail = (this.formularioDatos.controls.mail.value || "").toLowerCase();
		return currentMail !== this.originalMail.toLowerCase();
	}

	onMailChange() {
		this.emailExists = false;
	}

	private validateEmail(): Promise<boolean> {
		if (!this.isMailChanged()) {
			return Promise.resolve(true);
		}
		const mail = this.formularioDatos.controls.mail.value;
		return new Promise((resolve) => {
			this.registerService.checkEmailExists(mail).subscribe(
				(exists: boolean) => {
					this.emailExists = exists;
					resolve(!exists);
				},
				() => resolve(true)
			);
		});
	}

	onMobileOrPrefixChange() {
		this.smsSent = false;
		this.pendingSmsPin = "";
		this.pinError = false;
	}

	public changeLang(lang: string) {
		this.localStorage.setItem(LOCALSTORAGESTRINGS.LANG, lang);
		this.lang.setAppLang(this.availableLangs);
		this.idiomaSeleccionado.emit(
			this.localStorage.getItem(LOCALSTORAGESTRINGS.LANG)
		);
	}

	selectLang(_lang: any) {}

	closeModal(sendData?: any) {
		if (this.emailExists) {
			return;
		}

		if (this.isMobileChanged() && this.pendingSmsPin.length === 6) {
			this.validateEmail().then((valid) => {
				if (valid) {
					this.saveFormDataAndChangeMobile();
				}
			});
			return;
		}

		if (this.isMobileChanged()) {
			this.toaster.error(this.translateService.instant("CAMBIARMOVIL.VERIFYBEFORESUBMIT"));
			return;
		}

		this.validateEmail().then((valid) => {
			if (!valid) return;
			this.doCloseModal();
		});
	}

	private doCloseModal() {
		this.doSaveFormData();
		this.usersService
			.getListUserProfile()
			.pipe(take(1))
			.subscribe((res: any) => {
				this.usersService._listUserProfile = res.data;
				let orderedProfilesArray = [];
				res.data.forEach((element) => {
					if (element.idProfile == 2) {
						orderedProfilesArray[0] = element;
					}
					if (element.idProfile == 3) {
						orderedProfilesArray[1] = element;
					}
					if (element.idProfile == 4) {
						orderedProfilesArray[2] = element;
					}
					if (element.idProfile == 1) {
						orderedProfilesArray[3] = element;
					}
					if (element.idProfile == 5) {
						orderedProfilesArray[4] = element;
					}
				});
				this.setDefaultProfile(orderedProfilesArray);
			});
		this.masterService.getPreviousIdTutorialContext();
		this.activeModal.close(true);
	}

	private setDefaultProfile(orderedArray) {
		var BreakException = {};
		try {
			orderedArray.forEach((element) => {
				if (element.idProfile == 2) {
					this.store.dispatch(
						new selectProfile({ selectedProfile: "ESTUDIANTE" })
					);
					throw BreakException;
				}
				if (element.idProfile == 3) {
					this.store.dispatch(
						new selectProfile({ selectedProfile: "PROFESOR" })
					);
					throw BreakException;
				}
				if (element.idProfile == 4) {
					this.store.dispatch(new selectProfile({ selectedProfile: "PADRE" }));
					throw BreakException;
				}
				if (element.idProfile == 1) {
					this.store.dispatch(new selectProfile({ selectedProfile: "AUTOR" }));
					throw BreakException;
				}
				if (element.idProfile == 5) {
					this.store.dispatch(new selectProfile({ selectedProfile: "ADMIN" }));
					throw BreakException;
				}
			});
		} catch (e) {
			if (e !== BreakException) throw e;
		}
	}

	changePass() {
		this.screenView = 2;
	}

	changeMobile() {
		this.screenView = 3;
	}

	changeMail() {
		this.screenView = 4;
	}

	dropOut() {
		this.screenView = 5;
	}

	backToGeneral(change: boolean) {
		this.screenView = 1;
		if (change) {
			this.toaster.success(this.translateService.instant("CAMBIARPASS.OK"));
		}
	}

	ajustes() {
		this.modalService.open(ModalAjustesUsuarioComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90}`,
		});
		this.closeModal("");
	}

	onClickSelect(_event: MouseEvent) {
		// intencionalmente vacio: evita que el click burbujee y cierre los nb-select
	}
}
